<template>
  <div class="hello">
    <div class="header">
      <van-nav-bar title="缴费记录" left-text="返回" @click-left="backJump" left-arrow>
        <template #right>
          <van-icon name="ellipsis" />
        </template>
      </van-nav-bar>
    </div>
    <div class="content">
      <div style="margin:30px auto;width: 90%;">
        <button @click="hhh" style="width: 80px;height:30px;border:1px solid #2d86f6;border-radius: 5px;text-align: center;float: left;background-color: #fff;color:#2d86f6;">
          {{year}}
        </button>
        <div class="clear" style="clear: both;"></div>
        <van-popup v-model="show" position="bottom" style="width:100%;height: 30% ">
          <van-picker
              title="请选择年"
              show-toolbar
              :columns="columns"
              @confirm="onConfirm"
          />
        </van-popup>
      </div>
      <div class="xx" v-for="i in trans">
        <div class="bod" >
          <div style="border-bottom: 1px solid #dee1e5;">
            <p style="color: #8e8e8e;">{{i.createTime}}</p>
          </div>
          <div style="border-bottom: 1px solid #dee1e5;height: 95px;" @click="details(i,i.type)">

            <img src="../assets/dian.png" v-if="i.type == 0" style="width: 50px;height: 50px;float: left;margin-top: 20px;margin-left: 5px;margin-right: 10px" alt="">
            <img src="../assets/water.png" v-else style="width: 50px;height: 50px;float: left;margin-top: 20px;margin-left: 5px;margin-right: 10px" alt="">
            <div style="margin-top: 20px;float: left;">
              <span v-if="i.type == 0">电费</span>
              <span v-else>水费</span>
              |
              <span>{{i.houseHoldNumber}}</span>
              <p style="font-size: 13px;color: #8e8e8e;">{{i.createTime}}</p>
            </div>
            <div style="float: right;text-align: right;">
              <p v-if="i.status == 1" style="font-size: 14px;color: #8e8e8e;">支付成功</p>
              <p v-if="i.status == 0" style="font-size: 14px;color: #8e8e8e;">待支付</p>
              <p v-if="i.status == 3" style="font-size: 14px;color: #8e8e8e;">充值失败</p>
              <p v-if="i.status == 2" style="font-size: 14px;color: #8e8e8e;">充值成功</p>
              <span style="font-size: 20px;">￥{{i.money}}</span>
            </div>
          </div>
          <div class="clear"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'vant/lib/button/style'
import {record, selection} from "../common/api/allment"
import jump from "../common/jump";
export default {
  data() {
    return {
      year:'',
      show:false,
      columns: [],
      fees:"电费",
      trans:[]
    };
  },
  mounted() {
    var date = new Date();
    this.year = new Date().getFullYear()
    for(let i = 0;i<=5;i++){
      let year = date.getFullYear()-i;
      this.columns.push(year)
    }
    this.getContent()
  },
  methods: {
    getContent(){
      let first = this.year+"-01-01 00:00:00"
      let end = this.year+"-12-31 23:59:59"
      selection({startTime:new Date(first).getTime(),endTime:new Date(end).getTime()}).then((response)=>{
        this.trans = []
        this.trans = response.data.items
      })
    },
    backJump(){
      this.$destroy()
      jump.$emit('back')
      this.$router.go(-1)
    },
    details(trans,type){
      if(type == 0){
        this.$router.push({path:'/state',query:{orderNo:trans.orderNo}})
      }
      else if(type == 1){
        this.$router.push({path:'/waterstate',query:{orderNo:trans.orderNo}})
      }

    },
    hhh(){
      this.show = ! this.show
    },
    onConfirm(value, index) {
      this.year = `${value}`
      this.getContent()
      this.show = false
    },
  },
};
</script>

<style scoped>

.xx{
  width: 90%;
  border: 1px solid #dee1e5;
  border-radius: 10px;
  margin:30px auto;
}
.bod{
  width: 80%;
  margin:30px auto;
  padding-bottom: 50px;
}
.clear{
  clear: both;
}
</style>
